import React from 'react';
import routes from '../../constants/routes.constant';
import RouterLink from '../ui/router-link/RouterLink';
import './Footer.scss';
import { Icon } from '../ui/index';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer">
      <Container className="wrapper">
        <Row>
          <Col lg={6}>
            <Icon imgPath="/images/footer/visionhub-logo-white.png" className="footer-logo">
              <RouterLink className="footer-logo" path="/"></RouterLink>
            </Icon>
          </Col>
          <Col lg={6}>
            <ul>
              {routes.map(route =>
                route.footer && route.show ? (
                  <li className="footer__item">
                    <RouterLink path={route.path} key={route.label}>
                      {route.label}
                    </RouterLink>
                  </li>
                ) : null,
              )}
            </ul>
            <span className="copyright-text">© VisionHub 2016, All rights reserved</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
